import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { TournamentWidgetDataType, WidgetEntry } from '../types';

export function useTournamentWidgets() {
  const { tournamentStore } = useStores();
  const { hasLeaderboard, currentTournament } = tournamentStore;

  const tournamentWidgets: TournamentWidgetDataType[] = useMemo(() => {
    if (!hasLeaderboard || !currentTournament) {
      return [];
    }
    return [
      {
        key: 'tournament',
        dataTestId: 'tournament-widget',
        event: currentTournament,
      },
    ];
  }, [currentTournament, hasLeaderboard]);

  return useMemo(
    () => tournamentWidgets.map((data): WidgetEntry<'tournament'> => ({ data, type: 'tournament', id: data.key })),
    [tournamentWidgets],
  );
}
